import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-content-product',
  templateUrl: './no-content-product.component.html',
  styleUrls: ['./no-content-product.component.scss']
})
export class NoContentProductComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
